import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stack: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            alignSelf: 'strech',
            width: '100%',
            gap: 'xsmall-1.base',
        },
        stackItem: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            cursor: 'pointer',
            width: '100%',
            gap: 'xxsmall-1.base',
        },
        textContainer: {
            display: 'flex',
            flexDir: 'row',
            gap: remCalc(2),
            color: 'text.default',
            textAlign: 'center',
            textStyle: 'body-small',
            fontWeight: 'normal',
            cursor: 'pointer',
            marginRight: remCalc(12),
        },
        stackfilterLabelText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            cursor: 'pointer',
            textAlign: 'left',
            color: 'foreground.neutral.default',
        },
        filterHit: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            cursor: 'pointer',
            textAlign: 'left',
            color: 'foreground.neutral.subtle',
        },
    },
}
